// extracted by mini-css-extract-plugin
export default {"page":"VenuesBookPage_page__KAbCf","stepTitle":"VenuesBookPage_stepTitle__Vr9m8","wrapper":"VenuesBookPage_wrapper__bNe7Z","availableRooms":"VenuesBookPage_availableRooms__xxLz6"};